
import orderDetails from "@/app/(main)/orders/_components/OrderDetail";
import { createSlice } from "@reduxjs/toolkit";

const initialOrderState = {
    orderDetails: {},
    parentOrderDetails: {},
    orderId: "",
    address: {

    },
    shippingAddress: {

    },
    orderPaginationDetails: {

    },
    orderList: []
    

};

const orderSlice = createSlice({
    name: "order",
    initialState: initialOrderState,
    reducers: {
        setOrderDetails: (state, action) => {
            state.orderDetails = action.payload;
        },
        setParentOrderDetails: (state, action) => {
            state.parentOrderDetails = action.payload;
        },
        setOrderId: (state, action) => {
            state.orderId = action.payload;
        },
        setAddress: (state, action) => {
            state.address = action.payload;
        },
        setShippingAddress: (state, action) => {
            state.shippingAddress = action.payload;
        },
        setOrderPaginationDetails: (state, action) => {
            state.orderPaginationDetails = action.payload;
        },
        setOrderList: (state, action) => {
            state.orderList = action.payload;
        }
    },
});

export const { setOrderDetails, setParentOrderDetails, setOrderId, setAddress, setShippingAddress, setOrderPaginationDetails, setOrderList } = orderSlice.actions;
export default orderSlice.reducer;
